import ApplicationController from '../application_controller'

export default class DropdownController extends ApplicationController {
  static targets = ['panel']
  static values = { autoOpen: Boolean }

  connect() {
    if (this.autoOpenValue) {
      this.panelTarget.classList.add('vc-header__filter-panel--open')
    }
  }

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.toggle('vc-header__filter-panel--open')
  }

  close() {
    this.panelTarget.classList.remove('vc-header__filter-panel--open')
  }
}
